import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { queryClient } from './lib/queryClient';
import './styles/tokens.css';
import './styles/app.css';
import './styles/components.css';

const root = document.getElementById('md-studio-root');
if (!root) {
  // Mounted into Shopify Liquid: the root div is guaranteed to be there.
  // In standalone preview the index.html provides it. Either way, fail loud.
  throw new Error('MD Studio: #md-studio-root not found in document');
}

createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
